import AddRatePlan from './Add';

export default AddRatePlan;
